import React from "react";
import "./Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";

function Contact() {
  return (
    <div className="contact-page">
      <section className="contact-hero text-center text-white">
        <h1 className="contact-title">联系我们</h1>
        <p className="contact-subtitle">
        我们随时为您提供合适的解决方案
        </p>
      </section>

      <section className="contact-info container py-5">
        <div className="row g-4 justify-content-center">
          <div className="col-md-4">
            <div className="contact-card text-center">
              <div className="contact-icon">
                <FontAwesomeIcon icon={faMapMarkerAlt} size="3x" />
              </div>
              <h5 className="contact-label">地址</h5>
              <hr />
              <a
                href="https://maps.app.goo.gl/Us1vxHnjBNvfoZw69"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-brown"
              >
                在地图上查看
              </a>
            </div>
          </div>

          <div className="col-md-4">
            <div className="contact-card text-center">
              <div className="contact-icon">
                <FontAwesomeIcon icon={faEnvelope} size="3x" />
              </div>
              <h5 className="contact-label">EMAIL</h5>
              <hr />
              <p className="contact-text">contact@formeb.com</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="contact-card text-center">
              <div className="contact-icon">
                <FontAwesomeIcon icon={faLinkedin} size="3x" />
              </div>
              <h5 className="contact-label">LINKEDIN</h5>
              <hr />
              <a
                href="https://www.linkedin.com/company/pt-foremost-mebel-indonesia/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-brown"
              >
                访问我们
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
